import { Config } from 'next-i18n-router/dist/types';

const i18nConfig: Config = {
  locales: ['en', "zh-CN"],
  defaultLocale: 'en'
};

export default i18nConfig;
